export const downloadFile = (dxfString: string, islandName: string): void => {
	const date = new Date();
	const a = document.createElement('a');
	const file = new Blob([dxfString], { type: 'plain/text' });
	a.href = URL.createObjectURL(file);
	a.download = `${date.valueOf()}_${islandName}.dxf`;
	a.click();
};

